import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useOptionalTelephonyAgentEvents } from '../../contexts/TelephonyAgentEventsContext';
import type { TelephonySubjectType } from '../../types/telephony.events';

function getSubjectPath(type: TelephonySubjectType, id: string | number): { path: string; fallback: string } {
  switch (type) {
    case 'agreement':
      return { path: `/agreements/${id}`, fallback: '/agreements' };
    case 'lead':
      return { path: `/leads/${id}`, fallback: '/leads' };
    case 'ticket':
      return { path: `/ticket/${id}`, fallback: '/tickets' };
    default:
      return { path: '/', fallback: '/' };
  }
}

const TelephonySubjectNavigator: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const ctx = useOptionalTelephonyAgentEvents();
  const lastSeqRef = useRef<number>(0);

  useEffect(() => {
    const subjectNavEvent = ctx?.subjectNavEvent;
    if (!subjectNavEvent || subjectNavEvent.seq === lastSeqRef.current) return;
    lastSeqRef.current = subjectNavEvent.seq;

    const { path, fallback } = getSubjectPath(subjectNavEvent.subjectType, subjectNavEvent.subjectId);

    // Не навигируем если уже на целевой странице
    if (location.pathname === path) return;

    navigate(path, { state: { fallbackUrl: fallback, fromTelephony: true } });
  }, [ctx?.subjectNavEvent, navigate, location.pathname]);

  return null;
};

export default TelephonySubjectNavigator;
